module.exports = __webpack_public_path__ + "static/media/Springs_and_Shocks_Black.9b5da023.webp";